import { render, staticRenderFns } from "./ProcessSimulate.vue?vue&type=template&id=f89fe2ea&scoped=true"
import script from "./ProcessSimulate.vue?vue&type=script&lang=js"
export * from "./ProcessSimulate.vue?vue&type=script&lang=js"
import style1 from "./ProcessSimulate.vue?vue&type=style&index=1&id=f89fe2ea&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f89fe2ea",
  null
  
)

export default component.exports